import React, { lazy, Suspense } from 'react';

import { useUserContext } from '@context/UserContext';
import { ModalErrorBoundary } from '@services/errorService';
import { useRedirect } from '@services/routingService';
import { Loader } from '@sharedComponents/Loader';
import { EPage } from '@types';

import { BENEFIT_FREE_DELIVERY_MODAL_SIZE } from '../components';
import { useCartPageContext } from '../context';
import { EBenefitState } from '../model';
import { getDeliveryBenefit } from '../utils';

const LoyaltyFreeDeliveryModal = lazy(
  () => import('../components/CartLoyaltyWrapper/LoyaltyFreeDeliveryModal/LoyaltyFreeDeliveryModal'),
);

export const useLoyaltyFreeDeliveryModal = (onModalClose: () => void): JSX.Element => {
  const {
    state: {
      pricesSummary: { priceItemSummary },
      benefits: { loyalties },
    },
    settings: { minimalOrderPriceThreshold, orderPriceActivationThreshold, loyaltyModalImageUrl },
  } = useCartPageContext();

  const {
    state: { isLogged, isSubscribed },
  } = useUserContext();

  const redirect = useRedirect();

  const deliveryBenefit = getDeliveryBenefit(loyalties);

  const handleClick = () => {
    if (isSubscribed && isLogged) {
      onModalClose();
      return;
    }

    if (isLogged && !isSubscribed) {
      redirect(EPage.BENEFITS_PAGE);
      return;
    }

    redirect(EPage.REGISTER_PAGE);
  };

  return (
    <ModalErrorBoundary onError={onModalClose}>
      <Suspense fallback={<Loader height={BENEFIT_FREE_DELIVERY_MODAL_SIZE} />}>
        <LoyaltyFreeDeliveryModal
          isBenefitActive={deliveryBenefit?.state === EBenefitState.ACTIVE}
          modalImage={loyaltyModalImageUrl}
          isRegistered={isLogged}
          isSubscribed={isSubscribed}
          orderTotalPrice={priceItemSummary}
          onButtonClick={handleClick}
          nextOrderLimit={
            deliveryBenefit?.freeDeliveryLimit ? deliveryBenefit.freeDeliveryLimit : minimalOrderPriceThreshold
          }
          globalLimit={
            deliveryBenefit?.activationThreshold ? deliveryBenefit.activationThreshold : orderPriceActivationThreshold
          }
          time={deliveryBenefit?.date}
        />
      </Suspense>
    </ModalErrorBoundary>
  );
};
